<template>

    <div :class="className" :style="{height:height,width:width}" >
  </div>
</template>

<script>
import echarts from "echarts";
require("echarts/theme/macarons"); // echarts theme
import resize from "./mixins/resize";

export default {
  mixins: [resize],
  props: {
    className: {
      type: String,
      default: "chart"
    },
    width: {
      type: String,
      default: "100%"
    },
    height: {
      type: String,
      default: "350px"
    },
    autoResize: {
      type: Boolean,
      default: true
    },
    chartData: {
      type: Object,
      required: true
    },
  },
  data() {
    return {
      chart: null,
    };
  },
  watch: {
    chartData: {
      deep: true,
      handler(val) {
        this.setOptions(val);
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.initChart();
    });
  },
  beforeDestroy() {
    if (!this.chart) {
      return;
    }
    this.chart.dispose();
    this.chart = null;
  },
  methods: {
    initChart() {
      this.chart = echarts.init(this.$el, "macarons");
      this.setOptions(this.chartData);
    },
    setOptions({ expectedData, actualData,chartdatelist } = {}) {
      this.chart.setOption({
        xAxis: {
          data: chartdatelist, // 日期区间
          boundaryGap: true,
          axisTick: {
            show: false
          }
        },
        title:{
           show:true,
           text:"销售退货数量图",
           textStyle:{
             color:'#333',
             fontWeight:'bolder',
           }
        },
        grid: {
          left: 10,
          right: 10,
          bottom: 20,
          top: 30,
          containLabel: true
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross"
          },
          padding: [5, 10]
        },
        yAxis: {
          axisTick: {
            show: true
          }
        },
        legend: {
          data: ["盒数量", "箱数量"]
        },
        series: [
           {
            name: "盒数量",
            itemStyle: {
              normal: {
                color: "#FF005A",
                lineStyle: {
                  color: "#FF005A",
                  width: 2
                }
              }
            },
            smooth: true,
            type: "line",
            data: expectedData,
            animationDuration: 2800,
            animationEasing: "quadraticOu"
          },
          // {
          //   name: "箱数量",
          //   smooth: true,
          //   type: "line",
          //   itemStyle: {
          //     normal: {
          //       color: "#3888fa",
          //       lineStyle: {
          //         color: "#3888fa",
          //         width: 2
          //       },
          //       areaStyle: {
          //         color: "#f3f8ff"
          //       }
          //     }
          //   },
          //   data: actualData,
          //   animationDuration: 2800,
          //   animationEasing: "cubicInOut"
          // }
        ]
      });
    }
  }
};
</script>
